import TypeToReducer from 'type-to-reducer';

import { normalize, schema } from 'normalizr';

import {
  GET_CUSTOM_FIELDS_EMPLOYEES,
  SET_CUSTOM_FIELDS_EMPLOYEES_PAGINATION,
  SET_CUSTOM_FIELDS_EMPLOYEES_FILTERS,
  RESET_CUSTOM_FIELDS_EMPLOYEES,
  TOGGLE_CUSTOM_FIELDS_EMPLOYEE,
} from '../constants';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

const custom_fields_employee = new schema.Entity('custom_fields_employees'); // Esto es importante pero no se para que es.

const customFieldsEmployeesListInitialState = {
  filters: {
    fulltext: '',
    columnSearch: ['key', 'name', 'type'],
  },
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 0,
    totalDocs: 0,
    orderBy: 'createdAt',
    order: 'desc',
  },
  isLoading: false,
  needFetch: false,
  entities: { custom_fields_employees: {} },
  result: { custom_fields_employees: [] },
};

const getEmployeesPending = (state) => ({ ...state, isLoading: true, needFetch: false });
const getEmployeesFulfilled = (state, { payload }) => {
  const pagination = {
    ...state.pagination,
    limit: payload.limit,
    page: payload.page,
    totalPages: payload.totalPages,
    totalDocs: payload.totalDocs,
  };
  const normalized = normalize(
    { custom_fields_employees: payload.records },
    { custom_fields_employees: [custom_fields_employee] }
  ); // Aqui se cambia el nombre de como se guardara en redux en el selector
  return { ...state, isLoading: false, pagination, ...normalized };
};
const getCustomFieldsEmployeesRejected = (state) => ({ ...state, isLoading: false });

const setPagination = (state, { payload }) => ({
  ...state,
  needFetch: true,
  pagination: { ...state.pagination, ...payload },
});

const setFilters = (state, { payload }) => ({
  ...state,
  needFetch: true,
  filters: { ...state.filters, ...payload },
});

const reset = (state) => ({ ...customFieldsEmployeesListInitialState });

const togglePending = (state, { meta }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    custom_fields_employees: {
      ...state.entities.custom_fields_employees,
      [meta.id]: { ...state.entities.custom_fields_employees[meta.id], isLoading: true },
    },
  },
});

const toggleRejected = (state, { meta }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    custom_fields_employees: {
      ...state.entities.custom_fields_employees,
      [meta.id]: { ...state.entities.custom_fields_employees[meta.id], isLoading: false },
    },
  },
});

const toggleFulfilled = (state, { payload }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    custom_fields_employees: {
      // custom_fields_employees es el nombre a guardar de Redux (De la rama)
      ...state.entities.custom_fields_employees,
      [payload.project.id]: { ...payload.project, isLoading: false }, // project es el nombre que entrega el backend
    },
  },
});

const customFieldsEmployeesListReducers = {
  [GET_CUSTOM_FIELDS_EMPLOYEES]: {
    [PENDING]: getEmployeesPending,
    [FULFILLED]: getEmployeesFulfilled,
    [REJECTED]: getCustomFieldsEmployeesRejected,
  },
  [SET_CUSTOM_FIELDS_EMPLOYEES_PAGINATION]: setPagination,
  [SET_CUSTOM_FIELDS_EMPLOYEES_FILTERS]: setFilters,
  [RESET_CUSTOM_FIELDS_EMPLOYEES]: reset,
  [TOGGLE_CUSTOM_FIELDS_EMPLOYEE]: {
    [PENDING]: togglePending,
    [FULFILLED]: toggleFulfilled,
    [REJECTED]: toggleRejected,
  },
};

export default TypeToReducer(
  customFieldsEmployeesListReducers,
  customFieldsEmployeesListInitialState
);



// WEBPACK FOOTER //
// src/modules/secured/modules/custom_fields_employees/reducers/employees_list_reducers.js